import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { api } from '../api/http'

export const useAuth = create(persist((set, get) => ({
    user: null,
    token: null,
    login: async (email, password) => {
        const data = await api('/login', { method: 'POST', body: JSON.stringify({ email, password }) })
        localStorage.setItem('token', data.token)
        set({ token: data.token, user: data.user })
    },
    register: async (name, email, password, password2) => {
        const data = await api('/register', { method: 'POST', body: JSON.stringify({ name, email, password, password2 }) })
        localStorage.setItem('token', data.token)
        set({ token: data.token, user: data.user })
    },
    logout: () => {
        localStorage.removeItem('token')
        set({ user: null, token: null })
    },
    hydrateMe: async () => {
        const me = await api('/me')
        set({ user: me })
    }
}), { name: 'auth' }))
